module.exports = __webpack_public_path__ + "img/bj.e7a79061.png";